import React, { useEffect, useState } from "react";
import { formatNumber } from "utils/currencyFormat";
import { getDate } from "utils/formatDate";

const LoiNhuanBanHangTableRows = ({ list, onUpdateDaXem }) => {

    const handleDaXemClick = (e, orderID, taiSanID) => {
        e.preventDefault();
        e.stopPropagation();
        onUpdateDaXem(orderID, taiSanID);
    };

    return (
        <>
            {list.map((item, index) => {
                return (
                    <div className="custom-table-row" key={`${item.OrderID}-${item.TaiSanID}` || index} style={{ minHeight: "50px" }}>
                        <div className="custom-table-cell text-center flex-basis-6 flex-basis-6-sm disk-mobile">
                            <span className="mobile-column-name">STT</span>
                            <div className="center-wrapper word-break" style={{ justifyContent: 'center' }}>
                                {item.STT}
                            </div>
                        </div>
                        <div className="custom-table-cell flex-basis-9 flex-basis-9-sm">
                            <span className="mobile-column-name">Ngày</span>
                            <div className="center-wrapper text-center word-break" >
                                {getDate(item.CreatedDate)}
                            </div>
                        </div>
                        <div className="custom-table-cell flex-basis-12 flex-basis-12-sm" >
                            <span className="mobile-column-name">Mã ĐH</span>
                            <div className="center-wrapper word-break" >
                                {item.OrderCode}
                            </div>
                        </div>
                        <div className="custom-table-cell flex-basis-13 flex-basis-13-sm">
                            <span className="mobile-column-name">Tên tài sản</span>
                            <div className="center-wrapper word-break" >
                                {item.TenTaiSan}
                            </div>
                        </div>
                        <div className="custom-table-cell flex-basis-13 flex-basis-13-sm" >
                            <span className="mobile-column-name">Khách hàng</span>
                            <div className="center-wrapper word-break" >
                                {item.CustomerName}
                            </div>
                        </div>
                        <div className="custom-table-cell flex-basis-10 flex-basis-10-sm">
                            <span className="mobile-column-name">Tiền mua</span>
                            <div className="center-wrapper text-right word-break" >
                                <span className="color-tim-bold " >{formatNumber(item.GiaMua)}</span>
                            </div>
                        </div>
                        <div className="custom-table-cell flex-basis-10 flex-basis-10-sm" >
                            <span className="mobile-column-name">Phí SX</span>
                            <div className="center-wrapper text-right word-break" >
                                <span className="color-do-bold">{formatNumber(item.PhiSanXuat)}</span>
                            </div>
                        </div>
                        <div className="custom-table-cell flex-basis-10 flex-basis-10-sm">
                            <span className="mobile-column-name">Tiền bán</span>
                            <div className="center-wrapper text-right word-break" >
                                <span className="color-cam-bold">{formatNumber(item.GiaBan)}</span>
                            </div>
                        </div>
                        <div className="custom-table-cell flex-basis-10 flex-basis-10-sm" >
                            <span className="mobile-column-name">Lợi nhuận</span>
                            <div className="center-wrapper text-right word-break" >
                                <span className="color-xanh-bold">{formatNumber(item.LoiNhuan)}</span>
                            </div>
                        </div>
                        <div className="custom-table-cell flex-basis-7 flex-basis-7-sm" >
                            <span className="mobile-column-name">Đã xem</span>
                            <div className="center-wrapper text-center word-break" >
                                <a
                                    className="btn-icon-toggle"
                                    title="Click để đổi trạng thái"
                                    onClick={(e) => handleDaXemClick(e, item.OrderID, item.TaiSanID)}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <i className={item.IsReaded ? "fas fa-eye" : "fas fa-eye-slash"}
                                        style={{ fontSize: 18, color: item.IsReaded ? "#006666" : "#ccc" }} />
                                </a>
                            </div>
                        </div>
                    </div>
                )
            })}
        </>)
};

const LoiNhuanBanHangTable = ({
    list,
    TotalSoTienMua, TotalPhiSanXuat, TotalSoTienBan, TotalLoiNhuan,
    onUpdateDaXem, Total
}) => {

    if (!list || list.length === 0) {
        return (
            <div className="custom-table-row">
                <div className="custom-table-cell text-center red" style={{ width: "100%" }}>
                    Không có dữ liệu
                </div>
            </div>
        );
    }
    return (<>
        <div className="Left808x200 Table-main-new css-table-ds">
            <div className="table-mobile table-mobile-hover">
                <div className="custom-table-wrapper" style={{overflowX: 'auto', width: '100%'}}>
                        <div className="table-headers word-break"  style={{alignItems: 'stretch'}}>
                            <div className="custom-table-header flex-basis-6 flex-basis-6-sm" style={{ justifyContent: 'center'}}><p className="color-do-bold">STT <br /> <span className="color-do-bold">[{Total ? Total : 0}]</span></p></div>
                            <div className="custom-table-header flex-basis-9 flex-basis-9-sm" style={{ justifyContent: 'flex-start', paddingLeft: '30px' }}><p>Ngày</p></div>
                            <div className="custom-table-header flex-basis-12 flex-basis-12-sm" style={{ justifyContent: 'flex-start', paddingLeft: '10px' }}><p>Mã đơn hàng</p></div>
                            <div className="custom-table-header flex-basis-13 flex-basis-13-sm" style={{ justifyContent: 'flex-start', paddingLeft: '10px' }}><p>Tên tài sản</p></div>
                            <div className="custom-table-header flex-basis-13 flex-basis-13-sm" style={{ justifyContent: 'flex-start', paddingLeft: '10px' }}><p>Khách hàng</p></div>
                            <div className="custom-table-header text-right flex-basis-10 flex-basis-10-sm" style={{ justifyContent: 'flex-end', paddingRight: '10px' }}>
                                <p>Số tiền mua <br /> <span className="color-tim-bold">{formatNumber(TotalSoTienMua)}</span></p>
                            </div>
                            <div className="custom-table-header text-right flex-basis-10 flex-basis-10-sm " style={{ justifyContent: 'flex-end', paddingRight: '10px' }}>
                                <p>Phí sản xuất <br /> <span className="color-do-bold" >{formatNumber(TotalPhiSanXuat)}</span></p>
                            </div>
                            <div className="custom-table-header text-right flex-basis-10 flex-basis-10-sm" style={{ justifyContent: 'flex-end', paddingRight: '10px' }}>
                                <p>Số tiền bán <br /> <span className="color-cam-bold">{formatNumber(TotalSoTienBan)}</span></p>
                            </div>
                            <div className="custom-table-header text-right flex-basis-10 flex-basis-10-sm" style={{ justifyContent: 'flex-end', paddingRight: '10px' }}>
                                <p>Lợi nhuận <br /> <span className="color-xanh-bold">{formatNumber(TotalLoiNhuan)}</span></p>
                            </div>
                            <div className="custom-table-header text-center flex-basis-7 flex-basis-7-sm" style={{ justifyContent: 'center' }}><p>Đã xem</p></div>
                        </div>
                        <div className="custom-table-body">
                            <LoiNhuanBanHangTableRows
                                list={list}
                                onUpdateDaXem={onUpdateDaXem}
                            />
                        </div>
                    </div>
                </div>
            </div>
    </>)
};

export default LoiNhuanBanHangTable;